import api from "./axios";

export type OrgConfig = Record<string, string>;

export const configApi = {
  get: async (): Promise<OrgConfig> => {
    const res = await api.get<OrgConfig>("/config");
    return res.data;
  },

  update: async (updates: Record<string, string>): Promise<{ updated: number }> => {
    const res = await api.patch<{ updated: number }>("/admin/config", { updates });
    return res.data;
  },
};
